module.exports = __webpack_public_path__ + "static/media/logo-sm-dark.2e58279d.png";